import { useMemo, useState } from 'react';
import { DOWNLOAD_ECHART_TYPE, DOWNLOAD_DATA_TYPE } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';

export default function useDownload() {
  const [type, setType] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isDownloadEChart = useMemo(() => type === DOWNLOAD_ECHART_TYPE, [type]);
  const isDownloadData = useMemo(() => type === DOWNLOAD_DATA_TYPE, [type]);

  const handleDownloadClick = (payload: string) => {
    if (payload === type && isVisible) return;
    setType(payload);
    setIsVisible(true);
  };

  const handleDownloadCancel = () => {
    setIsVisible(false);
  };

  return {
    isDownloadEChart,
    isDownloadData,
    isVisible,
    setIsVisible,
    isLoading,
    setIsLoading,
    onClick: handleDownloadClick,
    onCancel: handleDownloadCancel,
  };
}
